import React from 'react';
import { MOOD_LABELS } from '../../utils/constants';
import { useTheme } from '../../hooks/useTheme';

const MoodSelector = ({ selectedMood, onMoodSelect }) => {
  const { theme } = useTheme();

  return (
    <div className={`p-6 rounded-xl ${theme === 'dark' ? 'bg-gray-800' : 'bg-white'} shadow-lg`}>
      <h3 className="font-semibold mb-4">Select your mood</h3>
      <div className="grid grid-cols-5 gap-3">
        {MOOD_LABELS.map(mood => (
          <button
            key={mood.value}
            onClick={() => onMoodSelect(mood.value)}
            className={`p-4 rounded-lg text-center transition-all ${
              selectedMood === mood.value 
                ? `${mood.bgColor} border-2 ${mood.borderColor} scale-105` 
                : theme === 'dark' ? 'bg-gray-700 hover:bg-gray-600' : 'bg-gray-100 hover:bg-gray-200'
            }`}
          >
            <div className="text-3xl mb-2">{mood.emoji}</div>
            <div className="text-sm font-medium">{mood.label}</div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default MoodSelector;